import { z } from 'zod';
import { BaseErrorSchema } from '../../shared/error.schema';
import { SurveySchema, SurveyRatingSchema, SurveyFrequencySchema, SurveyDurationSchema } from '../../entities/survey';
/**
 * Submit Survey Request Schema
 * POST /api/v2/survey/:id/submit
 * Survey ID provided as URL parameter
 *
 * The CLASSIC questions only. The Variant Check answer is a document of its own
 * with an endpoint of its own (plan 029), so it cannot ride along here — and a
 * submit that arrives while the check is still unanswered is rejected
 * form-level with `SURVEY_VARIANT_VERDICT_REQUIRED`, because completing the row
 * would foreclose an answer that can never be given afterwards.
 */ export const SubmitSurveyRequestSchema = z.object({
    rating: SurveyRatingSchema.optional(),
    frequency: SurveyFrequencySchema.optional(),
    duration: SurveyDurationSchema.optional()
});
/**
 * Submit Survey Response Schema
 * Returned on successful submission
 * Contains the updated survey object
 */ export const SubmitSurveyResponseSchema = z.object({
    survey: SurveySchema
});
/**
 * Submit Survey Error Schema
 * Returned when submission fails
 */ export const SubmitSurveyErrorSchema = BaseErrorSchema;

//# sourceMappingURL=submit-survey.schema.js.map